import { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import styles from './LandingPage.module.css'
import { ChamUploadButton } from "../../features/ChamUpload/ChamUpload";
import { ChamProjectsOpenButton } from "../ChamProjects/ChamProjects";
import home1Image from './assets/home-1.jpg';
import home2Image from './assets/home-2.jpg';
import home3Image from './assets/home-3.jpg';
import home4Image from './assets/home-4.jpg';

const backgroundImages = [home1Image, home2Image, home3Image, home4Image];

export default function LandingPage() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Rotate background image every 7 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => 
                (prevIndex + 1) % backgroundImages.length
            );
        }, 7000);

        return () => clearInterval(interval);
    }, []);

    return (
         <>
            <section 
                className={styles.landingSection}
                style={{ backgroundImage: `url(${backgroundImages[currentImageIndex]})` }}
            >
                <div className={styles.content}>
                    <div className={styles.cta}>
                        <h1>Explore Exceptional Homes</h1>
                        <p>Customize the Exterior of your next Home</p>

                        <div className={styles.landingControls}>
                            <Link to="/start" className={styles.btnPrimary}>Get Started</Link>
                            <ChamProjectsOpenButton className={styles.btnPrimary} title="My Home" noStyle /> 
                             
                        </div>
                    </div>
                </div>
            </section>
         </>
    )
}


